interface RuntimeConfig {
  tabTitle?: string;
  faviconPath?: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

// Loaded from /config.js (see public/config.js). On edge/edge-dev, nginx
// overwrites the built config.js at container start via
// server-go/nginx/docker-entrypoint.sh using WEBAPP_TAB_TITLE / WEBAPP_FAVICON_PATH.
export function applyRuntimeBranding(): void {
  const config = window.__RUNTIME_CONFIG__;
  if (!config) return;

  if (config.tabTitle) {
    document.title = config.tabTitle;
  }

  if (config.faviconPath) {
    let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }
    favicon.href = config.faviconPath;
  }
}
